import { withTranslation } from "react-i18next";

import React from 'react';
import { Link } from 'react-router-dom';
import { AffiliatorDashboardHeader } from '../Common/AffiliatorDashboardHeader';
import { Footer, Header } from '../Common';
import { AffiliatorSidebar } from '../Common/AffiliatorSidebar';
import Pagination from "react-js-pagination";
import AffiliatorLinks from '../../Models/AffiliatorLinks';
import "bootstrap/scss/bootstrap.scss";
class AffiliatorIndividualService extends React.Component {
    constructor(props) {
        super(props);
        let x = JSON.parse(localStorage.getItem('info'))
        if (x === null || x === '' || x.user_type_id !== 3) {
            alert(this.props.t('2'))
            this.props.history.push('/login/affiliator');
        };
        var retrievedObject = window.localStorage.getItem('info');
        var logged_user = JSON.parse(retrievedObject);
        this.state = {
            itemsCountPerPage: 10,
            pageRangeDisplayed: 5,
            total: [],
            activePage: 1,
            productsList: [],
            user: logged_user
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    handlePageChange(pageNumber) {
        var s = JSON.parse(window.localStorage.getItem('info'));
        AffiliatorLinks.getAffProducts(s.id, pageNumber).then(res => {
            if (res.data.payload != null) {
                this.setState({ productsList: res.data.payload, activePage: pageNumber, total: res.data.total, pageRangeDisplayed: this.state.pageRangeDisplayed, itemsCountPerPage: this.state.itemsCountPerPage });
            }
        })
    }

    componentWillMount() {
        AffiliatorLinks.getAffProducts(this.state.user.id, 1).then(res => {
            if (res.data.payload != null) {
                this.setState({ productsList: res.data.payload, total: res.data.total, pageRangeDisplayed: this.state.pageRangeDisplayed, itemsCountPerPage: this.state.itemsCountPerPage })
            }
        })
    }

    pagination() {
        // if (this.state.productsList.length < 10) {
        //     return (
        //         <div></div>
        //     )
        // } else {
            if (this.state.total > 10) {
                return (
                    <div className="row">
                        <div className="col-md-4"></div>
                        <div className="col-md-6 ml-5">
                            <Pagination
                                hideNavigation
                                activePage={this.state.activePage}
                                itemsCountPerPage={this.state.itemsCountPerPage}
                                totalItemsCount={this.state.total}
                                pageRangeDisplayed={this.state.pageRangeDisplayed}
                                onChange={this.handlePageChange.bind(this)}
                            />
                        </div>
                        <div className="col-md-2"></div>
                    </div>
                )
            }
        // }
    }

    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        if (isMobile) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="container-fluid">
                        <div className="row">
                            {/* <div className="col-md-4 input_name small-hidden">
                                <AffiliatorSidebar />
                            </div> */}
                            <div className="col-md-8">
                                <div className="mt-5 input_name big_font  pages_headers" style={{ width: '100%', fontSize: '20px', textAlign: 'left' }}>
                                    {this.props.t('0')}
                                </div>
                                <div className="">
                                    <div style={{ minHeight: "550px", textAlign: "center" }}>
                                        {this.state.productsList.map(group =>
                                            <div className="">
                                                <div className=" card">
                                                    <div className="col-md-12">
                                                        <div className="row">
                                                            <div className="card-title" style={{ width: "100%" }}>
                                                                <div className="mail_box" style={{ height: '55px', fontSize: '13px', marginLeft: '0px', paddingTop: '12px' }}>
                                                                    <div className="mail_box_input text-center" style={{ width: '100%' }}>{group.line_link}</div>
                                                                </div>
                                                            </div>
                                                            {/* <div className="card-title" style={{ width: "100%" }}>
                                                                <div className="mail_box" style={{ height: '78px', width: '100%', fontSize: '15px', marginLeft: '0px' }}>
                                                                    <div className="col-md-12 tr_blank_medium mt-2 pt-2"></div>
                                                                    <div className="mail_box_input text-center" style={{ backgroundColor: 'white', marginLeft: '10px', marginTop: '3px', width: '97%' }}>{group.web_link}</div>
                                                                </div>
                                                            </div> */}
                                                            <div className="col-md-12">
                                                                <div className="row">
                                                                    <div className="col-md-3 text-left">
                                                                        <span>{this.props.t('5')}</span>
                                                                    </div>
                                                                    <div className="col-md-9 text-left">
                                                                        <Link to={{ pathname: `/categories-details/${group.product_id}`, state: { id: group.product_id } }} className="gray"><span>{group.title}</span></Link>
                                                                    </div>
                                                                </div>
                                                                <div className="row">
                                                                    <div className="col-md-6 text-left">
                                                                        <span style={{ marginRight: "37px" }}>{this.props.t('3')}</span>
                                                                        {/* <span>{parseInt(group.affiliator_commission_amount)}</span> */}
                                                                        {(() => {
                                                                            if (group.renewal_type == 2) {
                                                                                return (
                                                                                    <span>{parseInt(group.affiliator_commission_amount)}<span style={{ fontSize: '15px' }}>({this.props.t('7')})</span></span>
                                                                                )
                                                                            } else if (group.renewal_type == 1) {
                                                                                return (
                                                                                    <span>{parseInt(group.affiliator_commission_amount)}</span>
                                                                                )
                                                                            }
                                                                        })()}
                                                                    </div>
                                                                    <div className="col-md-6 text-left">
                                                                        <span style={{ marginRight: "102px" }}>{this.props.t('13')}</span>
                                                                        {(() => {
                                                                            if (group.status == 'INACTIVE') {
                                                                                return (
                                                                                    <span style={{ color: 'red' }}>{this.props.t('8')}</span>
                                                                                )
                                                                            } else if (group.status == 'ACTIVE') {
                                                                                return (
                                                                                    <span style={{ color: 'green' }}>{this.props.t('11')}</span>
                                                                                )
                                                                            }
                                                                        })()}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <br />
                                            </div>
                                        )}
                                    </div>
                                    {this.pagination()}
                                </div>
                            </div>
                        </div>
                    </div>
                    <br />
                    <Footer />
                </div>
            )
        }
        else if (isDesktop) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid">
                        <div className="container">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4 input_name small-hidden">
                                        <AffiliatorSidebar />
                                    </div>
                                    <div className="col-md-8">
                                        <div className="mb-1 input_name big_font text-left pages_headers" style={{ width: '100%' }}>
                                            {this.props.t('0')}
                                    </div>
                                        <div className="">
                                            <div style={{ border: "1px solid #bababa", minHeight: "550px", padding: "2%", textAlign: "center" }}>
                                                {this.state.productsList.map(group =>
                                                    <div className="individual_title_box card">
                                                        <div className="col-md-12">
                                                            <div className="row">
                                                                <div className="card-title" style={{ width: "100%" }}>
                                                                    <div className="mail_box" style={{ height: '55px', fontSize: '13px', marginLeft: '0px', paddingTop: '12px' }}>
                                                                        <div className="mail_box_input text-center" style={{ width: '100%' }}>{group.line_link}</div>
                                                                    </div>
                                                                </div>
                                                                {/* <div className="card-title" style={{ width: "100%" }}>
                                                                <div className="mail_box" style={{ height: '78px', width: '100%', fontSize: '15px', marginLeft: '0px' }}>
                                                                    <div className="col-md-12 tr_blank_medium mt-2 pt-2"></div>
                                                                    <div className="mail_box_input text-center" style={{ backgroundColor: 'white', marginLeft: '10px', marginTop: '3px', width: '97%' }}>{group.web_link}</div>
                                                                </div>
                                                            </div> */}
                                                                <div className="col-md-12">
                                                                    <div className="row">
                                                                        <div className="col-md-3 text-left">
                                                                            <span>{this.props.t('5')}</span>
                                                                        </div>
                                                                        <div className="col-md-9 text-left">
                                                                            <Link to={{ pathname: `/categories-details/${group.product_id}`, state: { id: group.product_id } }} className="gray"><span>{group.title}</span></Link>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row">
                                                                        <div className="col-md-6 text-left">
                                                                            <div className="row col-md-12">
                                                                                <span><i style={{ marginRight: "37px" }}>{this.props.t('3')}</i></span>
                                                                                {(() => {
                                                                                    if (group.renewal_type == 2) {
                                                                                        return (
                                                                                            <div className="row col"><div>{parseInt(group.affiliator_commission_amount)}</div><div style={{ fontSize: '11px' ,marginTop:'4px'}}>({this.props.t('7')})</div></div>
                                                                                        )
                                                                                    } else if (group.renewal_type == 1) {
                                                                                        return (
                                                                                            <div>{parseInt(group.affiliator_commission_amount)}</div>
                                                                                        )
                                                                                    }
                                                                                })()}
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-md-6 text-left">
                                                                            <span><i style={{ marginRight: "102px" }}>{this.props.t('13')}</i></span>
                                                                            {(() => {
                                                                                if (group.status == 'INACTIVE') {
                                                                                    return (
                                                                                        <span style={{ color: 'red' }}>{this.props.t('8')}</span>
                                                                                    )
                                                                                } else if (group.status == 'ACTIVE') {
                                                                                    return (
                                                                                        <span style={{ color: 'green' }}>{this.props.t('11')}</span>
                                                                                    )
                                                                                }
                                                                            })()}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                        <br />
                                                    </div>
                                                )}
                                            </div>
                                            {this.pagination()}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br />
                    <Footer />
                </div>
            )
        }
    }
}
export { AffiliatorIndividualService }


AffiliatorIndividualService = withTranslation('src_Components_Affiliator_AffilitorIndividualService')(AffiliatorIndividualService);
